import styled from 'styled-components'
import { H1 } from '../Headings/styles'
import theme from '../../styles/theme'
export const StyledCard = styled.div``
export const CardTitle = styled(H1)`
  font-style: normal;
  padding: 10px 0px;
  margin: 0;
`
export const CardText = styled.p`
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.color.black};
`
